import { string } from 'yup'

export default string().required().max(80, 'Username can be more than 80 characters')
